import React, { useEffect, useState } from "react";
import API from '../Services/PlayPoint';
import APIS from '../Services/MemberShip';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import RefundList from "./index";
const AddRefund = () => {
    const [paymentAmount, setPaymentAmount] = useState("");
    const [playPoint, setPlayPoint] = useState("");
    const [selectMembership, setSelectMembership] = useState("");
    const [error, setError] = useState({});

    const handleFieldChange = (e, fieldName) => {
        const value = e.target.value;
        if (value.trim()) {
            setError((prevErrors) => {
                const updatedErrors = { ...(prevErrors || {}) };
                delete updatedErrors[fieldName];
                return updatedErrors;
            });
        }

        switch (fieldName) {
            case "paymentAmount":
                setPaymentAmount(value);
                break;
            case "playPoint":
                setPlayPoint(value);
                break;
            default:
                break;
        }
    };

    const validateFields = () => {
        const errors = {};
        const priceRegex = /^\d+(\.\d{1,2})?$/;

        if (!paymentAmount || String(paymentAmount).trim() === "") {
            errors.paymentAmount = "Amount is required";
        } else if (!priceRegex.test(String(paymentAmount))) {
            errors.paymentAmount = "Amount must be a valid number (e.g., 100 or 100.50)";
        }

        if (!playPoint || String(playPoint).trim() === "") {
            errors.playPoint = "SkyCoins is required";
        } else if (!priceRegex.test(String(playPoint))) {
            errors.playPoint = "SkyCoins must be a valid number (e.g., 100 or 100.50)";
        }

        setError(errors);
        return Object.keys(errors).length === 0;
    };

    const addRefund = async () => {
        if (!validateFields()) return;
        try {
            const payload = {
                payment_amount: paymentAmount,
                play_point: playPoint,
                membership_id: selectMembership,
            };
            const response = await API.addPlayPoints(payload);
            if (response?.status === 200) {
                toast.success(response?.data?.message || "SkyCoins created successfully!!");
                setTimeout(() => window.location.reload(), 2000);
            } else {
                toast.error(response?.data?.message || "SkyCoins not added. Please try again later.");
            }
        } catch (error) {
            console.error("Error adding refund:", error);
            toast.error("An unexpected error occurred. Please try again later.");
        }
    };

  
    const handleSubmit = async () => {
        if (!validateFields()) return;
        await addRefund();
    };

    const handleCancel = () => {
        setPlayPoint('');
        setPaymentAmount('');
        setSelectMembership('');
        setTimeout(() => window.location.reload(), 500);
    };

    return (
        <div>
 <div className="col-12 grid-margin stretch-card">
            <div className="card">
                <div className="card-body">
                    <h4 className="card-title">Refund</h4>
                    <div className="forms-sample">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Refund Amount <span style={{ color: "red" }}>*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Payment Amount"
                                        value={paymentAmount}
                                        onChange={(e) => handleFieldChange(e, "paymentAmount")}
                                    />
                                    {error?.paymentAmount && (
                                        <span className="text-danger" style={{ fontSize: "12px" }}>
                                            {error.paymentAmount}
                                        </span>
                                    )}
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>SkyCoins <span style={{ color: "red" }}>*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="SkyCoins"
                                        value={playPoint}
                                        onChange={(e) => handleFieldChange(e, "playPoint")}
                                    />
                                    {error?.playPoint && (
                                        <span className="text-danger" style={{ fontSize: "12px" }}>
                                            {error.playPoint}
                                        </span>
                                    )}
                                </div>
                            </div>

                        </div>

                        <div className="mt-3">
                            <button onClick={handleSubmit} type="button" className="btn btn-primary me-3">
                                Submit
                            </button>
                            <button onClick={handleCancel} className="btn btn-light">
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
             

            </div>
            
            
        </div>
           <RefundList/>
            <ToastContainer />
          </div>
    );
      
       
};

export default AddRefund;
